import { render, staticRenderFns } from "./youtubeIcon.vue?vue&type=template&id=417e5930&scoped=true"
import script from "./youtubeIcon.vue?vue&type=script&lang=js"
export * from "./youtubeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e5930",
  null
  
)

export default component.exports